// All site content — ported from the Python backend so the site works with no server.

export const STATS = [
  { id: "placements", value: 500, suffix: "+", label: "Placements since 2018", context: "Senior banking mandates across Monaco, Geneva & Paris" },
  { id: "shortlist", value: 11, suffix: " days", label: "Average time-to-shortlist", context: "Versus the 21-day industry average" },
  { id: "retention", value: 94, suffix: "%", label: "12-month retention rate", context: "Versus 78% industry benchmark" },
  { id: "repeat", value: 87, suffix: "%", label: "Client repeat rate", context: "Clients returning for further mandates" },
];

export const INTEL_COUNTERS = [
  { id: "monaco_aum", value: 100, prefix: "€", suffix: "B", label: "AuM booked in Monaco" },
  { id: "geneva_aum", value: 2.4, prefix: "CHF ", suffix: "T", label: "Wealth managed in Geneva", decimals: 1 },
  { id: "hedge_funds", value: 210, suffix: "+", label: "Active hedge funds in Geneva" },
  { id: "monaco_firms", value: 92, suffix: "", label: "Licensed financial firms in Monaco" },
];

export const TESTIMONIALS = [
  {
    id: "t1",
    quote: "Beyond Potentials is the only search firm that truly understands private banking culture. When we needed a Middle East specialist, they delivered three pre-qualified candidates in ten days — all with CHF 200M+ portable books.",
    name: "Marie-Laure D.",
    title: "Head of Private Banking",
    company: "Geneva-based Private Bank",
    market: "Geneva",
    service: "Recruitment",
  },
  {
    id: "t2",
    quote: "Celine's banking background is immediately apparent in how she assesses cultural fit. She doesn't just match CVs to job descriptions — she understands team dynamics and how a book actually transfers.",
    name: "Antoine R.",
    title: "Chief Executive Officer",
    company: "Monaco Family Office",
    market: "Monaco",
    service: "Recruitment",
  },
  {
    id: "t3",
    quote: "Their leadership development work reduced our regrettable turnover by 40% in twelve months. They stayed long after the placement — that is the difference between a vendor and a partner.",
    name: "Sophie M.",
    title: "Head of Human Resources",
    company: "Swiss Wealth Manager",
    market: "Geneva",
    service: "Talent Development",
  },
  {
    id: "t4",
    quote: "The Monaco-Geneva compensation intelligence they shared reshaped our entire retention strategy. No generalist recruiter could have produced that cross-market view.",
    name: "Karl B.",
    title: "Chief Operating Officer",
    company: "Geneva Hedge Fund",
    market: "Geneva",
    service: "Consulting",
  },
  {
    id: "t5",
    quote: "We engaged Beyond Potentials on the Beyond Partnership retainer. One partner across hiring, development and succession — it removed an enormous coordination burden from my desk.",
    name: "Isabelle C.",
    title: "Managing Director",
    company: "Monaco Private Bank",
    market: "Monaco",
    service: "Beyond Partnership",
  },
  {
    id: "t6",
    quote: "They placed our LATAM relationship manager in fourteen days. Eighteen months on, the book is performing ahead of plan. The discretion throughout was exactly what a search of this sensitivity required.",
    name: "Philippe G.",
    title: "Deputy CEO",
    company: "Geneva Private Bank",
    market: "Geneva",
    service: "Recruitment",
  },
];

export const CASE_STUDIES = [
  {
    slug: "latam-relationship-manager-geneva",
    title: "A LATAM Relationship Manager, placed in 14 days",
    market: "Geneva",
    service: "Recruitment",
    role: "Senior Relationship Manager",
    institution: "Geneva Private Bank",
    summary: "A Tier-1 Geneva private bank needed a LATAM specialist with a portable book — fast, and without signalling to the market.",
    image: "https://images.unsplash.com/photo-1554469384-e58fac16e23a?auto=format&fit=crop&w=1600&q=80",
    challenge: "Following an internal departure, the bank urgently needed a senior relationship manager covering Latin American UHNW clients. The search had to remain entirely confidential to protect existing client relationships, and any candidate had to demonstrate a genuinely portable book of at least CHF 250M.",
    solution: "We activated a network built over a decade inside Geneva's LATAM desks rather than advertising the role. Within a week we presented three pre-qualified, passive candidates, each assessed for cultural fit, compliance posture and realistic book portability — not just a matching CV.",
    outcome: "The bank hired within fourteen days. Eighteen months on, the relationship manager is performing ahead of plan with the majority of the targeted book successfully transferred.",
    metrics: [
      { value: "14 days", label: "From mandate to signed offer" },
      { value: "CHF 250M+", label: "Portable book transferred" },
      { value: "3", label: "Pre-qualified candidates presented" },
    ],
  },
  {
    slug: "monaco-family-office-build-out",
    title: "Building a Monaco family office investment team",
    market: "Monaco",
    service: "Recruitment",
    role: "Investment Team",
    institution: "Monaco Single-Family Office",
    summary: "A newly established single-family office needed an entire investment function built from scratch, discreetly.",
    image: "https://images.unsplash.com/photo-1602002418082-a4443e081dd1?auto=format&fit=crop&w=1600&q=80",
    challenge: "A principal relocating to Monaco needed to assemble a complete investment team — a CIO, two investment advisors and an operations lead — with absolute discretion and a strong cultural fit to a demanding, entrepreneurial founder.",
    solution: "We ran a single-mandate, retained search across all four roles in parallel, mapping the Monaco and Geneva talent pools and managing the candidate experience end to end to protect the principal's privacy.",
    outcome: "All four roles were filled within ten weeks. The team has been stable for over two years, and the office has since retained us for ongoing talent advisory.",
    metrics: [
      { value: "4 roles", label: "Filled in a single mandate" },
      { value: "10 weeks", label: "Full team operational" },
      { value: "100%", label: "Retention at 24 months" },
    ],
  },
  {
    slug: "retention-turnaround-leadership-development",
    title: "Reducing regrettable turnover by 40%",
    market: "Geneva",
    service: "Talent Development",
    role: "Senior Banking Team",
    institution: "Swiss Wealth Manager",
    summary: "A wealth manager was losing senior relationship managers to competitors and Dubai. We addressed the cause, not the symptom.",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80",
    challenge: "The firm was experiencing painful, expensive turnover among its best relationship managers — each departure threatening client assets and team morale. Exit interviews pointed to leadership and progression issues rather than pay alone.",
    solution: "We designed a twelve-month leadership development programme for team heads, paired with a retention diagnostic and a succession framework. The work was led by consultants who had themselves managed front-office banking teams.",
    outcome: "Regrettable turnover fell by 40% within a year, and internal promotion readiness improved markedly — reducing future hiring cost and protecting client relationships.",
    metrics: [
      { value: "-40%", label: "Regrettable turnover" },
      { value: "12 months", label: "Programme duration" },
      { value: "2x", label: "Internal promotion readiness" },
    ],
  },
  {
    slug: "compliance-build-out-post-basel",
    title: "Scaling a compliance function post Basel 3.1",
    market: "Paris",
    service: "Consulting",
    role: "Head of Compliance",
    institution: "Paris Investment Firm",
    summary: "Regulatory change forced a rapid build-out of senior compliance and risk talent in a tight market.",
    image: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?auto=format&fit=crop&w=1600&q=80",
    challenge: "New regulatory requirements demanded that the firm rapidly strengthen its compliance and risk leadership — a segment where qualified, bilingual senior talent is scarce and highly contested.",
    solution: "We combined a compensation benchmarking study with a targeted retained search, advising on an offer structure that was competitive without distorting the firm's internal pay equity.",
    outcome: "A Head of Compliance and two senior officers were hired within the quarter, on a compensation structure that held against two counter-offers.",
    metrics: [
      { value: "3 hires", label: "Senior compliance roles" },
      { value: "1 quarter", label: "Time to full team" },
      { value: "0", label: "Offers lost to counter" },
    ],
  },
];

export const INSIGHTS = [
  {
    slug: "geneva-eam-absorbing-senior-bankers",
    title: "Why Geneva's EAM sector is absorbing senior bankers faster than private banks can retain them",
    category: "Market Intelligence",
    date: "2026-05-28",
    reading_time: 7,
    author: "Celine Corletti",
    image: "https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=1600&q=80",
    excerpt: "The external asset manager channel is quietly reshaping Geneva's talent market. Here is what it means for your retention strategy.",
    body: [
      "Geneva's external asset management (EAM) sector has matured from a fringe alternative into a primary destination for senior relationship managers. The pull is structural, not cyclical: greater autonomy, a cleaner alignment between effort and reward, and the ability to serve clients without the constraints of a large institution's product shelf.",
      "For private banks, this is a retention problem disguised as a recruitment problem. Your best people are not leaving because a competitor offered more base salary. They are leaving because the EAM model offers a different relationship with their own book — and with their own time.",
      "The institutions that retain senior talent in 2026 are those that have understood this shift and responded with genuine progression, equity-like upside, and leadership development — not simply with a defensive counter-offer at the point of resignation.",
      "The cross-market picture matters too. A relationship manager weighing an EAM move in Geneva is also weighing the lifestyle and tax advantages of Monaco. Reading these markets in isolation produces incomplete strategy.",
    ],
  },
  {
    slug: "monaco-vs-geneva-compensation-benchmarks-2026",
    title: "Monaco vs Geneva: compensation benchmarks for senior RMs in 2026",
    category: "Salary & Compensation",
    date: "2026-05-12",
    reading_time: 9,
    author: "Beyond Potentials Intelligence",
    image: "https://images.unsplash.com/photo-1592861956120-e524fc739696?auto=format&fit=crop&w=1600&q=80",
    excerpt: "A side-by-side view of base, bonus and total compensation for senior relationship managers across Europe's two leading private banking hubs.",
    body: [
      "Headline base salaries for senior relationship managers in Monaco and Geneva look broadly comparable — but headline numbers conceal the real decision drivers. In Monaco, the absence of personal income tax materially changes net outcomes, which reshapes how candidates evaluate an offer.",
      "Bonus structures diverge more than base. Geneva institutions tend to weight discretionary bonus more heavily, while Monaco offers often carry a larger guaranteed component in year one to support relocation and book transfer.",
      "Our advice to clients is consistent: benchmark total net compensation, not gross base. A candidate comparing a Geneva and a Monaco offer is, whether they say so or not, running that calculation themselves.",
      "Use our interactive Compensation Calculator to model ranges by role, seniority and market — then talk to us about the qualitative factors the numbers never capture.",
    ],
  },
  {
    slug: "building-portable-book-private-bankers-guide",
    title: "Building a CHF 250M+ portable book: a private banker's guide",
    category: "Career Guidance",
    date: "2026-04-22",
    reading_time: 6,
    author: "Celine Corletti",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1600&q=80",
    excerpt: "Portability is not luck. It is the product of deliberate relationship architecture over years. Here is how the best build it.",
    body: [
      "A portable book is the single most valuable asset a relationship manager owns — and the most misunderstood. Portability is not a function of assets under management alone; it is a function of the depth and ownership of the underlying client relationships.",
      "The bankers who move successfully have spent years being the trusted point of contact rather than the institution's representative. They have diversified relationships across the family, not just the principal, and they have documented nothing that compromises confidentiality.",
      "For institutions hiring, the lesson is to assess portability honestly rather than optimistically. We model realistic transfer rates with every candidate — because an over-promised book damages everyone.",
    ],
  },
  {
    slug: "keeping-your-best-rm-from-dubai",
    title: "Why your best RM is considering Dubai — and how to keep them",
    category: "Leadership & Retention",
    date: "2026-04-03",
    reading_time: 5,
    author: "Beyond Potentials Intelligence",
    image: "https://images.unsplash.com/photo-1519501025264-65ba15a82390?auto=format&fit=crop&w=1600&q=80",
    excerpt: "The Gulf is recruiting aggressively from European private banking. Retention now requires more than a counter-offer.",
    body: [
      "Dubai and the wider Gulf are recruiting European private banking talent with conviction — offering tax advantages, fast-growing client bases and a sense of frontier opportunity. For a senior RM in Geneva or Monaco, the pitch is genuinely compelling.",
      "Retention strategies built around the counter-offer are failing because they address the symptom at the worst possible moment. By the time a resignation lands, the emotional decision has usually already been made.",
      "The institutions winning this contest are investing earlier — in leadership development, in clear progression, and in a culture that makes staying feel like the ambitious choice rather than the safe one.",
    ],
  },
  {
    slug: "esg-compliance-fastest-growing-hiring-segment",
    title: "ESG and compliance: the fastest-growing hiring segment in banking",
    category: "Market Intelligence",
    date: "2026-03-18",
    reading_time: 6,
    author: "Beyond Potentials Intelligence",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1600&q=80",
    excerpt: "Regulatory-driven demand for ESG and compliance talent is outpacing supply. The firms that plan ahead will pay less for better people.",
    body: [
      "Post Basel 3.1, demand for senior compliance, risk and ESG specialists has accelerated across Monaco, Geneva and Paris. This is now the fastest-growing segment of banking hiring — and the supply of genuinely qualified, bilingual senior talent has not kept pace.",
      "The result is predictable: compensation for these roles is rising faster than for front-office positions, and counter-offers are increasingly common. Firms that build their compliance leadership reactively are paying a premium for it.",
      "Our advice is to treat compliance leadership as a strategic hiring priority with its own succession plan — not as a box-ticking exercise driven by the latest examination.",
    ],
  },
  {
    slug: "q2-2026-monaco-geneva-talent-barometer",
    title: "Q2 2026 Monaco-Geneva Talent Barometer: hiring velocity accelerates",
    category: "Market Intelligence",
    date: "2026-06-02",
    reading_time: 8,
    author: "Beyond Potentials Intelligence",
    image: "https://images.unsplash.com/photo-1558271736-cd043ef2e855?auto=format&fit=crop&w=1600&q=80",
    excerpt: "Our quarterly read on hiring velocity, compensation movement and talent flow between Monaco and Geneva.",
    body: [
      "Hiring velocity across both markets accelerated in the second quarter, led by relationship management and compliance mandates. Time-to-hire compressed as institutions competed for a limited pool of senior, bilingual talent.",
      "Compensation continued its upward drift, with the sharpest movement in guaranteed first-year components for cross-border moves. Talent flow from Geneva to Monaco remained net positive, driven by lifestyle and tax considerations.",
      "The full barometer — with role-by-role compensation movement and segment-level demand — is available to clients on request.",
    ],
  },
];

export const MARKETS = [
  {
    slug: "monaco",
    name: "Monaco",
    tagline: "Europe's most concentrated private wealth ecosystem",
    currency: "EUR",
    image: "https://images.unsplash.com/photo-1592861956120-e524fc739696?auto=format&fit=crop&w=2000&q=80",
    intro: "Monaco combines a uniquely favourable tax environment with a dense concentration of private banks, family offices and UHNW residents. We have genuine, on-the-ground presence in the Principality — not a generalist's second-hand view.",
    stats: [
      { value: "€100B+", label: "Assets booked in Monaco" },
      { value: "92", label: "Licensed financial institutions" },
      { value: "0%", label: "Personal income tax" },
    ],
    segments: ["UHNW Relationship Management", "Family Office Build-out", "Multi-Family Office", "Wealth Planning", "Compliance & CCAF"],
    regulatory: "Financial activities are supervised by the Commission de Contrôle des Activités Financières (CCAF). Hiring senior staff requires careful attention to local authorisation and the realities of relocation.",
    mobility: "Monaco is a net importer of senior banking talent from Geneva, Zurich and London — with lifestyle and tax advantages the primary draw, balanced against limited housing supply.",
    chart: [
      { label: "RM", demand: 86 }, { label: "Family Office", demand: 78 },
      { label: "Compliance", demand: 64 }, { label: "Wealth Planning", demand: 52 }, { label: "Operations", demand: 41 },
    ],
  },
  {
    slug: "geneva",
    name: "Geneva",
    tagline: "The global capital of cross-border private banking",
    currency: "CHF",
    image: "https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=2000&q=80",
    intro: "Geneva is the world's leading centre for cross-border wealth management, with a deep ecosystem of private banks, external asset managers and a fast-growing hedge fund community. Our founder built her career inside this market.",
    stats: [
      { value: "CHF 2.4T", label: "Wealth managed in Geneva" },
      { value: "210+", label: "Active hedge funds" },
      { value: "$150B", label: "Hedge fund AuM" },
    ],
    segments: ["Senior Relationship Management", "External Asset Managers", "Hedge Funds", "Investment Advisory", "Compliance & Risk"],
    regulatory: "Institutions are supervised by FINMA. The post-consolidation landscape has raised both the bar and the stakes for senior hiring decisions.",
    mobility: "Geneva's EAM and hedge fund sectors are absorbing senior bankers from traditional private banks, while a steady flow of talent considers Monaco and the Gulf.",
    chart: [
      { label: "RM", demand: 92 }, { label: "EAM", demand: 81 },
      { label: "Hedge Fund", demand: 74 }, { label: "Compliance", demand: 69 }, { label: "Advisory", demand: 58 },
    ],
  },
  {
    slug: "paris",
    name: "Paris",
    tagline: "A resurgent European financial centre",
    currency: "EUR",
    image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=2000&q=80",
    intro: "Paris has reasserted itself as a major European financial hub, attracting institutions and talent post-Brexit. We support firms building wealth management, investment and control functions in the city.",
    stats: [
      { value: "Top 3", label: "EU financial centres" },
      { value: "Growing", label: "Post-Brexit relocation" },
      { value: "Bilingual", label: "Talent in demand" },
    ],
    segments: ["Private Banking", "Asset Management", "Compliance & Risk", "Investment Advisory", "Operations"],
    regulatory: "Supervised by the ACPR and AMF. Demand for bilingual senior talent in control functions is particularly strong.",
    mobility: "Paris is attracting returning French-national bankers from London and Switzerland, supported by a deepening pool of regulated roles.",
    chart: [
      { label: "Private Bank", demand: 71 }, { label: "Asset Mgmt", demand: 76 },
      { label: "Compliance", demand: 80 }, { label: "Advisory", demand: 55 }, { label: "Operations", demand: 48 },
    ],
  },
];

// ---------------------------------------------------------------------------
// Compensation engine (pure JS, identical logic to Python backend)
// ---------------------------------------------------------------------------
const COMP_ROLES = {
  "investment-advisor": { label: "Investment Advisor", base: 180, bonus: [25, 45] },
  "senior-relationship-manager": { label: "Senior Relationship Manager", base: 220, bonus: [40, 80] },
  "private-banker-director": { label: "Private Banker (Director)", base: 265, bonus: [50, 90] },
  "team-head": { label: "Team / Market Head", base: 320, bonus: [60, 110] },
  "compliance-officer": { label: "Senior Compliance / Risk Officer", base: 175, bonus: [20, 40] },
  "wealth-planner": { label: "Wealth Planner", base: 160, bonus: [20, 35] },
  "chief-investment-officer": { label: "Chief Investment Officer", base: 470, bonus: [70, 130] },
  "managing-director": { label: "Managing Director", base: 420, bonus: [70, 120] },
};

const COMP_LEVELS = {
  "5-8": { label: "5–8 years", mult: 0.78 },
  "8-12": { label: "8–12 years", mult: 1.0 },
  "12-16": { label: "12–16 years", mult: 1.18 },
  "16-20": { label: "16–20 years", mult: 1.34 },
  "20+": { label: "20+ years", mult: 1.5 },
};

const COMP_MARKETS = {
  geneva: { label: "Geneva", currency: "CHF", mult: 1.0 },
  monaco: { label: "Monaco", currency: "EUR", mult: 0.96 },
  paris: { label: "Paris", currency: "EUR", mult: 0.82 },
};

export function compensationOptions() {
  return {
    roles: Object.entries(COMP_ROLES).map(([id, v]) => ({ id, label: v.label })),
    levels: Object.entries(COMP_LEVELS).map(([id, v]) => ({ id, label: v.label })),
    markets: Object.entries(COMP_MARKETS).map(([id, v]) => ({ id, label: v.label, currency: v.currency })),
  };
}

export function calculateCompensation(role, level, market) {
  const r = COMP_ROLES[role];
  const lv = COMP_LEVELS[level];
  const mk = COMP_MARKETS[market];
  if (!r || !lv || !mk) return null;

  const medianBase = r.base * lv.mult * mk.mult;
  const baseLow = Math.round(medianBase * 0.85) * 1000;
  const baseMedian = Math.round(medianBase) * 1000;
  const baseHigh = Math.round(medianBase * 1.2) * 1000;

  const [bonusLowPct, bonusHighPct] = r.bonus;
  const bonusLow = Math.round(baseMedian * bonusLowPct / 100);
  const bonusHigh = Math.round(baseHigh * bonusHighPct / 100);

  return {
    role: r.label,
    level: lv.label,
    market: mk.label,
    currency: mk.currency,
    base: { low: baseLow, median: baseMedian, high: baseHigh },
    bonus_pct: { low: bonusLowPct, high: bonusHighPct },
    bonus: { low: bonusLow, high: bonusHigh },
    total: { low: baseLow + bonusLow, high: baseHigh + bonusHigh },
    chart: [
      { name: "Base (median)", value: baseMedian },
      { name: "Bonus (median)", value: Math.round((bonusLow + bonusHigh) / 2) },
    ],
    note: "Indicative ranges based on Beyond Potentials proprietary Monaco-Geneva benchmarking. Monaco figures are pre-tax in EUR; with no personal income tax, net outcomes are materially higher. Actual offers depend heavily on portable book size and quality.",
  };
}
